import { Component, EventEmitter, Input, Output, signal } from '@angular/core';
import { FormControl } from '@angular/forms';

@Component({
  selector: 'digi-password',
  templateUrl: './input-password.component.html',
  styleUrl: './input-password.component.scss'
})
export class InputPasswordComponent {
  @Input() label: string = '';            // Nhãn của input
  @Input() placeholder: string = '';       // Placeholder của input
  @Input() control!: FormControl;           // FormControl để quản lý giá trị và trạng thái
  @Input() errorMessage: string = '';      // Thông báo lỗi nếu có
  @Input() icon: boolean = false;
  @Input() showRequiredError: boolean = true;
  @Input() isSubmit: boolean = false;
  @Output() inputChanged = new EventEmitter<string>();

  hide = signal(true);
  clickEvent(event: MouseEvent) {
    this.hide.set(!this.hide());
    event.stopPropagation();
  }

  onInputChange(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.inputChanged.emit(value);  // gửi lên component cha
  }
}
